<template>
  <v-container tag="section" fluid>
    <v-row
      class="mx-auto mb-10"
      v-for="category in filteredCategories"
      :key="category.title"
    >
      <template>
        <v-col cols="12">
          <h2 id="categoria-relatorios" class="titulo">
            {{ category.title }}
          </h2>
        </v-col>
        <v-col
          v-for="powerup in category.powerups"
          :key="powerup.nome"
          xs="12"
          sm="6"
          md="4"
          xl="3"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :class="!powerup.ativo ? 'disabled-card' : ''"
                  :style="hover && !powerup.ativo ? 'cursor: not-allowed' : ''"
                  id="card-powerup"
                  class="mx-2 d-flex justify-center"
                  min-width="200px"
                  height="100%"
                  raised
                  :color="hover && powerup.ativo ? 'grey lighten-2' : 'white'"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  :to="powerup.ativo ? powerup.route : null"
                >
                  <v-row no-gutters align="center" justify="center">
                    <v-col cols="2">
                      <v-icon
                        class="my-auto d-flex justify-center"
                        :size="40"
                        color="primary"
                      >
                        {{ powerup.icon }}
                      </v-icon>
                    </v-col>
                    <v-col cols="10">
                      <v-card-text class="mx-auto my-auto">
                        <div class="subtitle-2" style="word-break: normal">
                          {{ powerup.nome }}
                        </div>
                        <div class="caption text--secondary">
                          {{ powerup.descricao }}
                        </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </v-hover>
            </template>
            {{ powerup.nome }}
          </v-tooltip>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      categorias: [
        {
          title: "Gestão de Usuários",
          powerups: [
            {
              nome: "Usuários",
              descricao: "Listagem e gerenciamento de permissões dos usuários",
              icon: "mdi-account-cog-outline",
              route: "/administracao/usuarios",
              ativo: true,
              hide: false,
            },
          ],
          hide: false,
        },
        {
          title: "Gerenciamento de Dados",
          powerups: [
            {
              nome: "Versionamento de Bases",
              descricao:
                "Listagem e gerenciamento das versões utilizadas nos painéis gerenciais",
              icon: "mdi-database-cog",
              route: "/administracao/versionamento-bases/",
              ativo: true,
              hide: false,
            },
          ],
          hide: false,
        },
        {
          title: "Configurações do Sistema",
          powerups: [
            {
              nome: "Configurações Regulatórias",
              descricao:
                "Configurações do sistema para atender demandas regulatórias específicas",
              icon: "mdi-cog-outline",
              route: "/administracao/company-indger-config",
              ativo: true,
              hide: false,
            },
            {
              nome: "Relatórios",
              descricao: "Listagem e liberação dos relatórios do sistema",
              icon: "mdi-clipboard-outline",
              route: "/administracao/relatorios",
              ativo: false,
              hide: true,
            },
            {
              nome: "Tipos de Serviços",
              descricao:
                "Cadastra e gerência os tipos de serviços (SERV_005) registrados no sistema",
              icon: "mdi-toolbox-outline",
              route: "/administracao/tipos-servicos",
              ativo: true,
              hide: false,
            },
            {
              nome: "Regionais",
              descricao:
                "Cadastra e gerência as Regionais registradas no sistema e seus Municípios",
              icon: "mdi-map-outline",
              route: "/administracao/regionais",
              ativo: true,
              hide: false,
            },
            {
              nome: "Municípios da Área de Concessão",
              descricao: "Gerenciar vínculo de municípios com a distribuidora",
              icon: "mdi-map-marker",
              route: "/administracao/area-concessao",
              ativo: true,
              hide: false,
            },
            {
              nome: "Áreas",
              descricao: "Administrar as Áreas registradas no sistema",
              icon: "mdi-sitemap",
              route: "/administracao/areas",
              ativo: true,
              hide: false,
            },
            {
              nome: "Gerências",
              descricao: "Administrar as Gerências registradas no sistema",
              icon: "mdi-file-tree-outline",
              route: "/administracao/gerencias",
              ativo: true,
              hide: false,
            },
            {
              nome: "Governança - Manual da Ferramenta",
              descricao: "Cadastro do Manual do Sistema",
              icon: "mdi-bank",
              route: "/administracao/governanca/manual-ferramenta",
              ativo: false,
              hide: true,
            },
            {
              nome: "Governança - Responsáveis por Tema",
              descricao:
                "Gerencia os responsáveis centrais por tema do sistema",
              icon: "mdi-bank",
              route: "/administracao/governanca/responsaveis-temas",
              ativo: true,
              hide: false,
            },
          ],
          hide: false,
        },
        {
          title: "Auxiliares",
          powerups: [
            {
              nome: "Relatórios com Falha",
              descricao:
                "Listagem de todos os relatórios criados com ocorrência de erro",
              icon: "mdi-clipboard-alert-outline",
              route: "/administracao/relatorios-criados-status-falha",
              ativo: false,
            },
          ],
          hide: true,
        },
      ],
    }),
    computed: {
      filteredCategories() {
        return this.categorias
          .filter((category) => !category.hide)
          .map((category) => ({
            ...category,
            powerups: category.powerups.filter((powerup) => !powerup.hide),
          }));
      },
    },
  };
</script>

<style>
  .disabled-card {
    opacity: 0.5;
    border-color: transparent !important;
  }
  .titulo {
    font-family: "styrene A";
    font-weight: 500;
    color: #3c4858 !important;
    font-size: 18px !important;
  }
</style>
